export default "__VITE_ASSET__BROu1pQ0__"